import { useEffect, useState } from 'react'
import { About } from './About'
import Banners from './Banners'
import Footer from './Footer'
import { Header } from './Header'
import { Products } from './Products'
import Spec from './Spec'
import Trailers from './Trailers'
import CookieConsentAndAnalytics from './CookieConsent'

function App() {
    const RELEASE_DATE_PT = new Date('2026-06-18T06:00:00-07:00').getTime()
    const [currentTime, setCurrentTime] = useState(Date.now())

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(Date.now())
        }, 10_000)

        return () => clearInterval(interval)
    }, [])
    const isReleased = currentTime >= RELEASE_DATE_PT
    return (
        <>
            <div className='bg-space'>
                <CookieConsentAndAnalytics />
                <Header  isReleased={isReleased} />
                <div className='my-20 md:my-40'>
                    <h1 className='text-white/80 text-md md:text-lg  italic text-center tracking-widest'>
                        The fate of two races depends on you.
                    </h1>
                </div>
                <About />
                <Trailers isReleased={isReleased} />
                <Products />
                <Banners />
                <Spec isReleased={isReleased} />
                <Footer />
            </div>
        </>
    )
}

export default App
